import { useEffect, useState } from "react";
import { Box, Flex, IconButton, Image, Stack } from "@chakra-ui/react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import dashboardIcon from "../../assets/Images/dashboard.svg";
import LeadsIcon from "../../assets/Images/lead-Icon.svg";
import AdminControllIcon from "../../assets/Images/admin-control-icon.svg";
import SupportIcon from "../../assets/Images/support.svg";
import CollapseIcon from "../../assets/Images/CollapseOn.svg";
import Logo from "../../assets/Images/Infusive-Logo.svg";
import CollapseLogo from "../../assets/Images/CollapseLogo.svg";
import * as routesNames from "../../constant/routes";
import MyDiv from "./sidebar.style";
import { useAuth } from "../../hooks/useAuth";
import InfusiveLogo from "../../assets/Images/Infusive-logo (2).svg";
import InfusiveMedia from "../../assets/Images/Infusive Media.svg";
import ReportsIcon from "../../assets/Images/Report-Icon.svg";
import DashboardIcon from "../../assets/Images/dashboard-icon.svg";
import CompanyIcon from "../../assets/Images/company-icon.svg";
import TaskIcon from "../../assets/Images/Task-icon.svg";
import ProjectIcon from "../../assets/Images/Project-icon.svg";
import MasterIcon from "../../assets/Images/master-icon.svg";
import InvoiceIcon from "../../assets/Images/invoice_icon.svg";
import AllBillingPlansIcon from "../../assets/Images/bill_icon.svg";

type SubMenuItem = {
  id: number;
  label: string;
  link: string;
};

type MenuItem = {
  id: number;
  menuName: string;
  menuLogo: string;
  link?: string;
  subMenu?: SubMenuItem[];
};

interface SidebarProps {
  toggleSidebar: boolean;
  handleSidePanel: () => void;
  activePortal: string;
}

const Sidebar = (props: SidebarProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const Menus: MenuItem[] = [];

  if (hasPermission("Dashboard")) {
    Menus.push({ id: 1, menuName: "Dashboard", menuLogo: DashboardIcon, link: routesNames.DASHBOARD });
  }

  if (hasPermission("Company")) {
    Menus.push({ id: 2, menuName: "Companies", menuLogo: CompanyIcon, link: routesNames.COMPANY });
  }



  if (hasPermission("LeadPool") || hasPermission("MyLeads") || hasPermission("Poc") || hasPermission("MyTeamLead") || hasPermission("Duplicatelead") || hasPermission("BulkUploadLead") || hasPermission("Meeting") || hasPermission("CreatedLead") || hasPermission("MyTeamCreatedLead")) {
    const subMenu: SubMenuItem[] = [];
    if (hasPermission("LeadPool")) subMenu.push({ id: 42, label: "LeadPool", link: routesNames.LEADPOOL });
    // if (hasPermission('LeadLists'))
    if (hasPermission("Meeting")) subMenu.push({ id: 49, label: "Meetings", link: routesNames.MEETING });
    if (hasPermission("Reminder")) subMenu.push({ id: 50, label: "Reminders", link: routesNames.FOLLOWUPLIST });
    //   subMenu.push({ id: 43, label: "Leads", link: routesNames.LEADLIST })
    if (hasPermission("MyLeads")) subMenu.push({ id: 44, label: "My Leads", link: routesNames.MYLEADS });
    if (hasPermission("MyTeamLead")) subMenu.push({ id: 45, label: "My Team Leads", link: routesNames.MYTEAMLEAD });
    if (hasPermission("Duplicatelead")) subMenu.push({ id: 46, label: "DuplicateLead", link: routesNames.DUPLICATELEAD });
    if (hasPermission("BulkUploadLead")) subMenu.push({ id: 47, label: "Bulk Upload Lead", link: routesNames.BULKUPLOADLEAD });
    if (hasPermission("Poc")) subMenu.push({ id: 48, label: "Poc", link: routesNames.POC });
    if (hasPermission("CreatedLead")) subMenu.push({ id: 49, label: "Created Lead", link: routesNames.CREATEDLEAD });
    if (hasPermission("MyTeamCreatedLead")) subMenu.push({ id: 50, label: "My Team Created Lead", link: routesNames.MYTEAMCREATEDLEAD });
    Menus.push({ id: 4, menuName: "Leads", menuLogo: LeadsIcon, subMenu: subMenu });
  }

  if (hasPermission("Customer")) {
    Menus.push({ id: 16, menuName: "Customers", menuLogo: SupportIcon, link: routesNames.CUSTOMERLIST });
  }

  if (hasPermission("Project") || hasPermission("MyProject") || hasPermission("AllocatedProject")) {
    const subMenu: SubMenuItem[] = [];
    if (hasPermission("Project")) subMenu.push({ id: 70, label: "All Projects", link: routesNames.PROJECT });
    if (hasPermission("MyProject")) subMenu.push({ id: 71, label: "My Project", link: routesNames.MYPROJECT });
    if (hasPermission("AllocatedProject")) subMenu.push({ id: 72, label: "Allocated Project", link: routesNames.ALLOCATEDPROJECT });

    if (subMenu.length > 0) {
      Menus.push({ id: 15, menuName: "Projects", menuLogo: ProjectIcon, subMenu: subMenu });
    }
  }

  if (hasPermission("TaskManagement") || hasPermission("MyTask") || hasPermission("ReviewTask") || hasPermission("AllTask")) {
    const subMenu: SubMenuItem[] = [];

    if (hasPermission("TaskManagement")) subMenu.push({ id: 190, label: "Task Time Sheet", link: routesNames.TASKMANAGEMENT });
    if (hasPermission("MyTask")) subMenu.push({ id: 191, label: "My Task", link: routesNames.MYTASK });
    if (hasPermission("ReviewTask")) subMenu.push({ id: 192, label: "Review Task", link: routesNames.REVIEWTASK });
    if (hasPermission("AllTask")) subMenu.push({ id: 193, label: "All Task", link: routesNames.ALLTASK });
    if (hasPermission("MyTaskTimeSheet")) subMenu.push({ id: 194, label: "MyTask TimeSheet", link: routesNames.MYTASKTIMESHEET });

    Menus.push({ id: 19, menuName: "Task", menuLogo: TaskIcon, subMenu: subMenu });
  }

if (hasPermission("InvoiceListPage")) {
    Menus.push({ id: 20, menuName: "Invoice", menuLogo: InvoiceIcon, link: routesNames.INVOICELISTPAGE });
  }

if (hasPermission("AllBillingPlans")) {
    Menus.push({ id: 21, menuName: "Billing", menuLogo: AllBillingPlansIcon, link: routesNames.AllBillingPlans });
  }



  if (hasPermission("LeadAssignReport") || hasPermission("LeadCreationReport") || hasPermission("EmployeePerformance") || hasPermission("ComparisonChart") || hasPermission("ResourceBandwidthProjectCost") || hasPermission("ResourceRevenueReport")) {
    const subMenu: SubMenuItem[] = [];
    if (hasPermission("LeadAssignReport")) subMenu.push({ id: 61, label: "Assignment Report", link: routesNames.LeadAssignReport });
    if (hasPermission("LeadCreationReport")) subMenu.push({ id: 62, label: "Creation Report", link: routesNames.LeadCreationReport });
    if (hasPermission("EmployeePerformance")) subMenu.push({ id: 63, label: "Employee Performance", link: routesNames.EMPLOYEEPERFORMANCE });
    if (hasPermission("ComparisonChart")) subMenu.push({ id: 63, label: "Comparison Chart", link: routesNames.COMPARISONCHART });
    if (hasPermission("ResourceBandwidthProjectCost")) subMenu.push({ id: 65, label: "Resource Bandwidth & Project Cost", link: routesNames.RESOURCEBANDWIDTHPROJECTCOST });
    if (hasPermission("ResourceRevenueReport")) subMenu.push({ id: 66, label: "Resource Revenue", link: routesNames.RESOURCEREVENUEREPORT });
    if (hasPermission("SourceWiseReport")) subMenu.push({ id: 88, label: "Source Wise Report", link: routesNames.SOURCEWISEREPORT });
    Menus.push({ id: 6, menuName: "Report", menuLogo: ReportsIcon, subMenu: subMenu });
  }

  // if (hasPermission("CostingReport") || hasPermission("ResourceBandwidthProjectCost") || hasPermission("ResourceRevenueReport") || hasPermission("LeadAssignReport")) {
  //   const subMenu: SubMenuItem[] = [];
  //   if (hasPermission("ResourceBandwidthProjectCost") || hasPermission("CostingReport") || hasPermission("LeadAssignReport")) {
  //     subMenu.push({ id: 65, label: "Resource Bandwidth & Project Cost", link: routesNames.RESOURCEBANDWIDTHPROJECTCOST });
  //   }
  //   if (hasPermission("ResourceRevenueReport") || hasPermission("CostingReport") || hasPermission("LeadAssignReport")) {
  //     subMenu.push({ id: 66, label: "Resource Revenue", link: routesNames.RESOURCEREVENUEREPORT });
  //   }
  //   if (subMenu.length > 0) {
  //     Menus.push({ id: 8, menuName: "Costing Report", menuLogo: ReportsIcon, subMenu: subMenu });
  //   }
  // }

  if (hasPermission("Signature")) {
    Menus.push({ id: 14, menuName: "Signature", menuLogo: SupportIcon, link: routesNames.SIGNATURE });
  }



  if (hasPermission("Roles") || hasPermission("Users") || hasPermission("Pages")) {
    const subMenu: SubMenuItem[] = [];
    if (hasPermission("Roles")) subMenu.push({ id: 31, label: "Roles", link: routesNames.ROLES });
    if (hasPermission("Pages")) subMenu.push({ id: 32, label: "Pages", link: routesNames.PAGES });
    if (hasPermission("Users")) subMenu.push({ id: 33, label: "Users", link: routesNames.USERS });
    if (hasPermission("EmailSetting")) subMenu.push({ id: 34, label: "Email Setting", link: routesNames.EMAILSETTING });
    if (hasPermission("TeamManagement")) subMenu.push({ id: 35, label: "Team Management", link: routesNames.TEAMMANAGEMENT });
    if (hasPermission("FieldMaskingSetting")) subMenu.push({ id: 36, label: "Field Masking Setting", link: routesNames.FIELDMASKINGSETTING });
    if (hasPermission("EmailTemplate")) subMenu.push({ id: 37, label: "Email Template", link: routesNames.EMAITEMPLATE });
    if (hasPermission("GstSetting")) subMenu.push({ id: 38, label: "Gst Setting", link: routesNames.GSTSETTING });
    if (hasPermission("ServiceTeamManagement")) subMenu.push({ id: 39, label: "Service Team Management", link: routesNames.SERVICETEAMMANAGEMENT });
    if (hasPermission("TaskNotificationSettings")) subMenu.push({ id: 40, label: "Task Notification Setting", link: routesNames.TASKNOTIFICATIONSETTINGS });
    
    Menus.push({ id: 3, menuName: "Admin Controller", menuLogo: AdminControllIcon, subMenu: subMenu });
  }

  if (hasPermission("RaiseTickets")) {
    const subMenu: SubMenuItem[] = [];
    if (hasPermission("RaiseTickets")) subMenu.push({ id: 71, label: "Raise Ticket", link: routesNames.SUPPORT });

    Menus.push({ id: 7, menuName: "Support", menuLogo: SupportIcon, subMenu: subMenu });
  }

  if (hasPermission("IndustryType") || hasPermission("Designation") || hasPermission("Country") || hasPermission("City") || hasPermission("State") || hasPermission("Source") || hasPermission("Status") || hasPermission("ServiceInterestedIn") || hasPermission("DuplicateLeadSetting") || hasPermission("Target") || hasPermission("Product") || hasPermission("WebsiteSetting") || hasPermission("LocationMaster") || hasPermission("Agency") || hasPermission("Milestone") || hasPermission("MilestoneMaster") || hasPermission("TaskTypeMaster") || hasPermission("TaskType") || hasPermission("TaskStatusMaster") || hasPermission("TaskStatus") || hasPermission("DisqualifyReason") || hasPermission("DisqualifyReasonMaster") || hasPermission("Department")) {
    const subMenu: SubMenuItem[] = [];
    if (hasPermission("IndustryType")) subMenu.push({ id: 51, label: "Industy Type", link: routesNames.INDUSTRYTYPES });
    if (hasPermission("Designation")) subMenu.push({ id: 52, label: "Designation", link: routesNames.DESIGNATION });
    if (hasPermission("Country")) subMenu.push({ id: 54, label: "Country", link: routesNames.COUNTRY });
    if (hasPermission("City")) subMenu.push({ id: 54, label: "City", link: routesNames.CITY });
    if (hasPermission("State")) subMenu.push({ id: 55, label: "State", link: routesNames.STATE });
    if (hasPermission("Source")) subMenu.push({ id: 56, label: "Source", link: routesNames.SOURCE });
    if (hasPermission("Status")) subMenu.push({ id: 57, label: "Status", link: routesNames.STATUS });
    if (hasPermission("DuplicateLeadSetting")) subMenu.push({ id: 59, label: "DuplicateLeadSetting", link: routesNames.DUPLICATELEADSETTINGS });
    // if (hasPermission("Target")) subMenu.push({ id: 223, label: "Target", link: routesNames.TARGET });
    if (hasPermission("WebsiteSetting")) subMenu.push({ id: 62, label: "Website Setting", link: routesNames.WEBSITESETTINGS });
    if (hasPermission("ServiceInterestedIn")) subMenu.push({ id: 58, label: "Service Interested In", link: routesNames.SERVICEINTERESTEDIN });
    if (hasPermission("Product")) subMenu.push({ id: 60, label: "Product", link: routesNames.PRODUCT });
    if (hasPermission("LocationMaster")) subMenu.push({ id: 63, label: "Location Master", link: routesNames.LOCATIONMASTER });
    if (hasPermission("Agency")) subMenu.push({ id: 64, label: "Agency", link: routesNames.AGENCY });
    if (hasPermission("Milestone") || hasPermission("MilestoneMaster")) subMenu.push({ id: 65, label: "Milestone Master", link: routesNames.MILESTONE });
    if (hasPermission("TaskTypeMaster") || hasPermission("TaskType")) subMenu.push({ id: 66, label: "Task Type Master", link: routesNames.TASKTYPEMASTER });
    if (hasPermission("TaskStatusMaster") || hasPermission("TaskStatus")) subMenu.push({ id: 67, label: "Task Status Master", link: routesNames.TASKSTATUSMASTER });
    if (hasPermission("DisqualifyReason") || hasPermission("DisqualifyReasonMaster")) subMenu.push({ id: 68, label: "Disqualify Reason", link: routesNames.DISQUALIFYREASON });
     if (hasPermission("Department")) subMenu.push({ id: 69, label: "Department Master", link: routesNames.DEPARTMENT });

    Menus.push({ id: 5, menuName: "Masters", menuLogo: MasterIcon, subMenu: subMenu });
  }
  if (hasPermission("Target")) {
    const subMenu: SubMenuItem[] = [];
    if (hasPermission("Target"))
      subMenu.push({ id: 223, label: "Target", link: routesNames.TARGET });
    Menus.push({ id: 7, menuName: "Settings", menuLogo: AdminControllIcon, subMenu: subMenu });
  }
  const [menuId, setMenuId] = useState<number | null>(null);
  const ActiveMenu = Menus;

  useEffect(() => {
    if (location.pathname === routesNames.PROJECTDETAIL || location.pathname === routesNames.ALLOCATEDPROJECTDETAIL) {
      const projMenu = ActiveMenu.find((item) => item.id === 15);
      if (projMenu) {
        setMenuId(15);
        return;
      }
    }
    const activeItem = ActiveMenu.find((item) => item.link === location.pathname || item.subMenu?.some((sub) => sub.link === location.pathname));
    if (activeItem) {
      setMenuId(activeItem.id);
    }
  }, [location.pathname]);

  const handleMenu = (itemId: number) => {
    const selectedItem = Menus.find((item) => item.id === itemId);
    if (!selectedItem) return;

    if (selectedItem.link) {
      navigate(selectedItem.link);
      setMenuId(itemId);
      return;
    }

    if (selectedItem.subMenu?.length) {
      setMenuId(itemId);
      const firstSub = selectedItem.subMenu[0];
      if (firstSub) navigate(firstSub.link);
    }
  };

  return (
    <MyDiv>
      <Box className={props.toggleSidebar ? "sidebar_collapse" : "sidebar_wrapper"}>
        {/* COLLAPSE BUTTON */}
        <Box className="collapse-button">
          <IconButton
            className={props.toggleSidebar ? "" : "collpase_icon"}
            onClick={props.handleSidePanel}
            icon={<Image src={CollapseIcon} />}
            aria-label=""
            // bg="#E6EEFA"
            bg="transparent"
          />
        </Box>

        {/* LOGO */}
        <Flex className="logo_wrapper" justifyContent={props.toggleSidebar ? "center" : "flex-start"} ml={3}>
          {/* Always show icon */}
          <Image src={InfusiveLogo} className="logo_icon" boxSize={14} />

          {/* Show text ONLY when expanded */}
          {!props.toggleSidebar && <Image src={InfusiveMedia} className="logo_text" />}
        </Flex>
        <Box className={props.toggleSidebar ? "sidebar_box_toggle" : "sidebar_box"}>
          <Stack spacing="3" className="menu_box">
            {ActiveMenu.map((item) => {
              const isActiveMenu = item.id === menuId;
              const hasSubMenu = item.subMenu?.length;
              const isExpanded = isActiveMenu && hasSubMenu;

              return (
                <Box key={item.id}>
                  <Flex className={isActiveMenu ? "active_menu menu_item" : "menu_item"} onClick={() => handleMenu(item.id)}>
                    <NavLink to={item.link ?? ""} className="font-poppins text_lg font_dark" style={{ justifyContent: props.toggleSidebar ? "center" : "" }}>
                      <Image src={item.menuLogo} className="icon_size" />
                      {!props.toggleSidebar && item.menuName}
                    </NavLink>
                  </Flex>

                  {isExpanded && !props.toggleSidebar && (
                    <Box className="submenu_wrapper">
                      {item.subMenu?.map((subItem) => {
                        const isSubActive = location.pathname === subItem.link;
                        return (
                          <NavLink key={subItem.id} to={subItem.link} className={isSubActive ? "active_submenu submenu_item" : "submenu_item"}>
                            • {subItem.label}
                          </NavLink>
                        );
                      })}
                    </Box>
                  )}
                </Box>
              );
            })}
          </Stack>
        </Box>
      </Box>
    </MyDiv>
  );
};

export default Sidebar;
